var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash',{attrs:{"icon":"fa fa-dollar","titulo":"PAGAMENTOS SGTEC","subTitulo":"UFI","qtd":_vm.qtd,"qtd2":_vm.qtd2,"mostrarQtd":true,"mostrarQtd2":true,"loading":_vm.loading},nativeOn:{"click":function($event){return _vm.$router.push({ name: 'Sgtec_Uabs_Pagamentos' })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }